"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _section = _interopRequireDefault(require("@site/pattern-library-core/section"));
var _price = _interopRequireDefault(require("@site/pattern-library-core/price"));
var _tag = _interopRequireDefault(require("@site/pattern-library-core/tag"));
var _text = _interopRequireDefault(require("@ux/text"));
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _motionFunctions = require("@site/pattern-library-core/motion-functions");
var _reactIntersectionObserver = require("react-intersection-observer");
var _scrollPosition = _interopRequireDefault(require("../animation/motion-parallax/scroll-position"));
var _breakpoints = require("@site/pattern-library-utils/breakpoints");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _actions = _interopRequireDefault(require("../../elements/other/actions"));
var _layers = require("@site/pattern-library-utils/layers");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const StickyNavbar = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "StickyNavbar",
  class: "pl-s1aibnpz"
});
const SectionContainer = /*#__PURE__*/(0, _react2.styled)(_section.default)({
  name: "SectionContainer",
  class: "pl-s12txl8n",
  vars: {
    "s12txl8n-0": [({
      visible
    }) => visible ? '0%' : '-100%']
  }
});
const NavContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "NavContainer",
  class: "pl-nh1rauw"
});
const MobileNavContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "MobileNavContainer",
  class: "pl-m1n4p5ew"
});
const ContentWrapper = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "ContentWrapper",
  class: "pl-cahcojp"
});
const PriceWrapper = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "PriceWrapper",
  class: "pl-p1eehr9r"
});

/**
 * StickyOffer Component
 *
 * This component displays a sticky offer section that becomes visible based on the scroll position
 *
 * @param {Object} props React props
 * @param {string} props.id The unique identifier for the component
 * @param {string} props._name The name of the component
 * @param {Object} props.priceLockup The price lockup object containing price details
 * @param {Object} props.cta The call-to-action object containing CTA details
 * @param {string} props.tagLabel The label text for the tag
 * @param {string} props.labelDesign The design style for the label
 * @param {string} props.heading The heading text for the offer
 * @param {string} props.targetId The ID of the target element to observe for visibility
 * @param {string} props.partial The partial style for the section
 * @param {string} props.mobileCtaTextOverride The override text for the mobile CTA
 * @returns {React.ReactElement} StickyOffer Component
 * @public
 */
function StickyOffer({
  id,
  _name,
  priceLockup,
  cta,
  tagLabel,
  labelDesign,
  heading,
  targetId,
  partial,
  mobileCtaTextOverride
}) {
  const ref = (0, _react.useRef)(null);
  const [isVisible, setIsVisible] = (0, _react.useState)(false);
  const {
    scrollY,
    scrollDirection
  } = (0, _scrollPosition.default)();
  const {
    ref: sentinelRef,
    inView
  } = (0, _reactIntersectionObserver.useInView)({
    threshold: 0,
    root: null,
    rootMargin: '100px'
  });
  (0, _react.useEffect)(() => {
    const sentinel = document.getElementById(targetId);
    if (sentinel) {
      sentinelRef(sentinel);
    }
    setIsVisible(false);
  }, [targetId, sentinelRef]);
  (0, _react.useEffect)(() => {
    const sentinel = document.getElementById(targetId);
    if (!sentinel) return;
    const targetTop = sentinel.getBoundingClientRect().top;
    if (scrollY > targetTop) {
      setIsVisible(true);
    } else if (inView) {
      setIsVisible(true);
    } else if (scrollDirection === 'up' && !inView) {
      setIsVisible(false);
    }
  }, [scrollY, scrollDirection, inView, targetId]);
  return /*#__PURE__*/_react.default.createElement(StickyNavbar, {
    id: "sticky-offer",
    ref: ref
  }, /*#__PURE__*/_react.default.createElement(SectionContainer, {
    id: `id-${id}`,
    _name: _name,
    verticalMargin: "none",
    visible: isVisible,
    partial: partial || 'bluectas'
  }, /*#__PURE__*/_react.default.createElement(NavContainer, null, /*#__PURE__*/_react.default.createElement(ContentWrapper, {
    className: isVisible ? 'active' : ''
  }, tagLabel && /*#__PURE__*/_react.default.createElement(_tag.default, {
    text: tagLabel,
    design: labelDesign,
    size: "sm"
  }), heading && /*#__PURE__*/_react.default.createElement(_text.default.h4, {
    as: "title",
    className: "banner-headline",
    size: 3,
    text: heading
  })), /*#__PURE__*/_react.default.createElement(PriceWrapper, null, priceLockup && /*#__PURE__*/_react.default.createElement(_price.default, (0, _extends2.default)({
    align: "start"
  }, priceLockup)), cta && /*#__PURE__*/_react.default.createElement(_actions.default, {
    actionsLayout: "button-set",
    ctas: [{
      ...cta,
      size: 'small'
    }]
  }))), /*#__PURE__*/_react.default.createElement(MobileNavContainer, {
    "data-cy": "mobile-cta"
  }, cta && /*#__PURE__*/_react.default.createElement(_actions.default, {
    actionsLayout: "button-set",
    ctas: [{
      ...cta,
      text: mobileCtaTextOverride || cta?.text,
      size: 'small'
    }]
  }))));
}
var _default = exports.default = StickyOffer;
StickyOffer.propTypes = {
  id: _propTypes.default.string,
  _name: _propTypes.default.string,
  priceLockup: _propTypes.default.object,
  cta: _propTypes.default.object,
  tagLabel: _propTypes.default.string,
  labelDesign: _propTypes.default.string,
  heading: _propTypes.default.string,
  targetId: _propTypes.default.string,
  partial: _propTypes.default.string,
  mobileCtaTextOverride: _propTypes.default.string
};